import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  currentPage: 1,
  nextButtonDisabled: false,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
